























import { iosCustomUrlSchemes, navigateToHlAppDeeplink } from '@/models/hl-app/custom-url-scheme'
import FullscreenNotificationLayout from '@spa/hl-app/components/fullscreen-notification/FullscreenNotificationLayout.vue'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    FullscreenNotificationLayout,
  },
})
export default class ErrorView extends Vue {
  @Prop({ required: true })
  readonly title: string

  closePage(): void {
    navigateToHlAppDeeplink(iosCustomUrlSchemes.close)
  }
}
